import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withApollo } from "@apollo/react-hoc";

import {
  Container,
  Row,
  Col,
  Card,
  FormGroup,
  Input,
  Button,
  Label,
  CardBody,
} from "reactstrap";
import Header from "../../organisms/guest-header";
import { FORGOT_PASSWORD } from "../../../api/user";
import {
  showToast,
  validarCampo,
  validarCampos,
  t,
} from "../../../utils/utils";
import {
  EMPTY_VALIDATION,
  EMAIL_VALIDATION,
  REMOVE_JWT,
  REMOVE_REFRESH_JWT,
  REMOVE_USER_EMAIL,
  REMOVE_USER_INFO,
} from "../../../constants";
import T from "../../atoms/translate";

class RecoverAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        email: props.match.params.email || "",
      },
      labels: {
        email: t("email"),
      },
      errors: {},
      validations: {
        email: [EMPTY_VALIDATION, EMAIL_VALIDATION],
      },
      saving: false,
      emailSended: false,
    };
  }

  componentDidMount() {
    REMOVE_JWT();
    REMOVE_REFRESH_JWT();
    REMOVE_USER_EMAIL();
    REMOVE_USER_INFO();
  }

  validarCampo(name) {
    const { data, validations, errors, labels } = this.state;
    this.setState({
      errors: validarCampo(data, validations, errors, labels, name),
    });
  }

  validarFormulario() {
    const { data, validations, labels } = this.state;
    let errors = { ...this.state.errors };
    errors = validarCampos(data, validations, errors, labels, ["email"]);
    this.setState({ errors });
  }

  handleChange(evt) {
    const target = evt.target;
    let data = { ...this.state.data };
    data[target.name] = target.value;

    this.setState({ data });
  }

  onSubmit = async (e) => {
    await this.setState({ saving: true });
    await this.validarFormulario();

    const errors = { ...this.state.errors };
    if (Object.keys(errors).length > 0) {
      showToast(t("corrijaLosErrores"), "error");
      this.setState({ saving: false });
      return;
    }

    const { mutate } = this.props.client;
    const { data } = this.state;
    try {
      //enviar correo forgot
      const res = await mutate({
        mutation: FORGOT_PASSWORD,
        variables: {
          email: data.email,
        },
      });
      if (res && res.data && res.data.forgotPassword) {
        showToast(t("exitoAlEnviarRecuperar"));
        this.setState({ emailSended: true });
      } else {
        showToast(t("errorAlEnviarRecuperar"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        showToast(graphQLErrors[0].message, "error");
      } else if (networkError) {
        showToast(t("errorAlEnviarRecuperar"), "error");
      } else {
        showToast(t("errorAlEnviarRecuperar"), "error");
      }
      this.setState({ saving: false });
    }
  };
  render() {
    const { saving, data, errors, emailSended } = this.state;
    return (
      <>
        <Header />
        <Container style={{ minHeight: "80vh" }}>
          <Row>
            <Col xs="11" md="6" lg="5" className="mx-auto">
              <Card className="mt-5 box-shadow rounded-xg border-gris-100 generic-card">
                <CardBody>
                  <Row>
                    <Col xs="12">
                      <h3 className="text-center text-primary">
                        <T i18nKey={"recuperarContrasena"} />
                      </h3>
                    </Col>
                  </Row>
                  {emailSended ? (
                    <Row>
                      <Col xs="12">
                        <p>
                          <T
                            i18nKey={"mensajeExitoAlEnviarRecuperar"}
                            values={{ email: data.email }}
                          />
                        </p>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs="12">
                        <FormGroup>
                          <Label>
                            <T i18nKey={"email"} />
                          </Label>
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            defaultValue={data.email}
                            placeholder={t("ingresaTuEmail")}
                            onBlur={async (e) => {
                              await this.handleChange(e);
                              this.validarCampo("email");
                            }}
                            className={`${errors.email ? "is-invalid" : ""}`}
                          ></Input>
                          <div className="invalid-feedback">{errors.email}</div>
                        </FormGroup>
                      </Col>
                      <Col xs="8" md="6" lg="5" className="text-center mx-auto">
                        <Button
                          block
                          className="fw-500"
                          color="primary"
                          onClick={this.onSubmit}
                          disabled={saving}
                        >
                          {saving
                            ? t("espere...")
                            : t("enviarCorreoRecuperacion")}
                        </Button>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col xs="12" className="mt-4">
                      <hr />
                    </Col>
                    <Col xs="12" className="text-center">
                      <Link to="/">
                        <T i18nKey="yaTienesCuenta" />
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* <div>
          <Col xs="12" className="text-center border-top py-3 mt-3 bg-white">
            uStart - 2020
          </Col>
        </div> */}
      </>
    );
  }
}

export default withApollo(RecoverAccount);
